<template>
    <component :is="component" :name="name" :mode="mode">
        <slot></slot>
    </component>
</template>

<script setup lang="ts">
import { computed, TransitionGroup, Transition, markRaw } from "vue";

const props = withDefaults(
    defineProps<{
        name?: "fade-in" | "fade-out" | "fade";
        mode?: "in-out" | "out-in" | "default";
        isGroup?: boolean;
    }>(),
    {
        name: "fade",
        mode: "default",
        isGroup: false,
    }
);

const component = computed(() => (props.isGroup ? markRaw(TransitionGroup) : markRaw(Transition)));
</script>
